import {hasPermission} from 'common/HelperFunctions'
import {BUILD_VERSION} from 'common/constants'
import {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router'
import {RootState} from 'setup'

import {ILayout, useLayout} from '../../core'

const Footer = () => {
  const {config} = useLayout()
  const intl = useIntl()
  const generalSettings = useSelector<RootState>(
    ({mainReducer}) => mainReducer.generalSettings,
    shallowEqual
  ) as any

  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        {!generalSettings?.powered_by_text && (
          <>
            <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
            <a
              href='https://ilmversity.com'
              className='text-gray-800 text-hover-primary me-1'
              target='_blank'
              rel='noreferrer'
            >
              Ilmversity
            </a>
          </>
        )}
        {!!generalSettings?.powered_by_text && (
          <span
            className='me-1'
            dangerouslySetInnerHTML={{__html: generalSettings?.powered_by_text}}
          />
        )}
        | <Link to='/institute/change-log'>Build: {BUILD_VERSION}</Link>
      </div>

      {!generalSettings?.powered_by_text && (
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a
              href='https://ilmversity.com/about-us/'
              target='_blank'
              className='menu-link ps-0 pe-2'
              rel='noreferrer'
            >
              About
            </a>
          </li>
          <li className='menu-item'>
            <a
              href='https://ilmversity.com/contact/'
              target='_blank'
              className='menu-link pe-2'
              rel='noreferrer'
            >
              Contact
            </a>
          </li>
          {hasPermission('knowledge_base') && (
            <li className='menu-item'>
              <a
                href='https://ilmversity.com/knowledge-base/'
                target='_blank'
                className='menu-link pe-2 text-primary'
                rel='noreferrer'
              >
                <span className='fas fa-book-open me-1' />
                {intl.formatMessage({id: 'MENU.KNOWLEDGE_BASE'})}
              </a>
            </li>
          )}
        </ul>
      )}
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
